import type { TimesheetMaterialRecord, TimesheetRecord } from "@/features/timesheetFlow/timesheetFlowTypes";
import { buildInvoicePreviewPositionsFromMaterials } from "@/features/timesheetFlow/billingAnswerPositionUtils";
import type { DokumentDetail } from "@/lib/dokumente";
import type { EditorPosition } from "@/pages/dokumente/documentPositionModel";
import { getTimesheetDisplayNumber } from "@/pages/stundennachweise/timesheetFilterLogic";

/** Synthetisches Rechnungsdokument für die Rückfragen-Vorschau. */
export function buildBillingInvoicePreviewDoc(timesheet: TimesheetRecord): DokumentDetail {
  const now = new Date().toISOString();
  const display = getTimesheetDisplayNumber(timesheet) || String(timesheet.id);
  return {
    id: 0,
    dokument_typ: "rechnung",
    status: "entwurf",
    dokument_nummer: null,
    display_number: `Vorschau SN ${display}`,
    revision_index: 0,
    betreff:
      String(timesheet.auftrag_display || timesheet.auftragsnummer || "").trim() ||
      "Rechnungsvorschau",
    waehrung: "EUR",
    summe_netto: 0,
    summe_steuer: 0,
    summe_brutto: 0,
    belegdatum: timesheet.date_to || timesheet.date_from || now.slice(0, 10),
    auftrag_id: timesheet.auftrag_id ?? null,
    kunden_id:
      Number.isFinite(Number(timesheet.kunden_id)) && Number(timesheet.kunden_id) > 0
        ? Number(timesheet.kunden_id)
        : null,
    kunde_name: (timesheet.kunde_name as string | undefined) || null,
    created_by: "vorschau",
    created_at: now,
    updated_at: now,
    version: 1,
    positionen: [],
    verknuepfungen: [],
  };
}

export function buildBillingInvoicePreviewPositions(
  materials: TimesheetMaterialRecord[],
  excludeMaterialIds?: Iterable<number>,
): EditorPosition[] {
  return buildInvoicePreviewPositionsFromMaterials(materials, { excludeMaterialIds });
}
